import styled from "styled-components";

import {
	Form,
	FormRow1,
	FormRow2,
	FormRow3,
	FormMsgSubmit,
} from "../../styled";

let S = {};
S.Form = Form;
S.FormRow1 = FormRow1;
S.FormRow2 = FormRow2;
S.FormRow3 = FormRow3;
S.FormMsgSubmit = FormMsgSubmit;

S.TopContainer = styled.div`
	margin-bottom: 15px;
	border-bottom: 1px solid var(--border);
	padding-bottom: 15px;

	& > div {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
		justify-items: center;

		& > div {
			display: flex;
			flex-direction: column;
			align-items: center;
			text-align: center;
		}
	}

	& > .grid2 {
		grid-template-columns: 1fr;
	}

	& h3 {
		color: var(--red);
		margin: 0;
		margin-top: 15px;
		font-size: 1rem;
		line-height: 22px;
	}

	& p {
		margin: 0;
		line-height: 22px;
	}
`;

S.Grid = styled.div`
	display: grid;
	grid-template-columns: 1fr 8fr 1fr;
	grid-gap: 0;

	@media only screen and (max-width: 967px) {
		grid-template-columns: 1fr;
	}
`;

S.LeftContainer = styled.div`
	width: 100%;
	padding: 0;
	padding-left: 15px;

	@media only screen and (max-width: 967px) {
		order: 2;
		padding-left: 0;
	}
`;

S.Container = styled.div`
	width: 100%;
	margin: 0 auto;
	padding: 0;
	padding-right: 15px;

	@media only screen and (max-width: 767px) {
		padding: 0 5%;
	}

	@media only screen and (max-width: 649px) {
		padding: 0;
	}
`;

S.Details = styled.div`
	width: 100%;
	padding: 0;
	margin: 0;
	border: 1px solid #ddd;

	& > p.lead {
		text-align: center;
		font-size: 1.05rem;
		padding: 15px;
		border-bottom: 1px solid #ddd;
	}

	& > div {
		padding: 0 15px;
		padding-bottom: 15px;
		display: grid;
		grid-template-columns: 1fr 1fr;
		grid-gap: 25px;

		@media only screen and (max-width: 767px) {
			grid-template-columns: 1fr;
		}

		& > div {
			& > h3 {
				text-align: center;
				color: var(--red);
				margin: 0;
				margin-bottom: 10px;
				font-size: 1.05rem;
				line-height: 22px;
			}

			& > p {
				margin: 0;
				line-height: 22px;
				text-align: justify;
			}
		}
	}
`;

S.Hdg = styled.div`
	& h4 {
		margin: 0;
		padding: 0;
		font-size: 1.1rem;
		line-height: 28px;
	}

	& h5 {
		margin: 0;
		padding: 0;
		margin-top: 30px;
		font-size: 0.95rem;
		color: var(--red);
	}

	& p {
		margin: 0;
		padding: 0;
		margin-top: 2.5px;
		line-height: 20px;
	}
`;

S.Note = styled.div`
	width: 100%;
	background: #fff;
	border: 1px solid #ddd;
	padding: 7.5px 15px;

	& > p {
		line-height: 23px;
	}
`;

export default S;
